export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const ANIMATION_DURATION = 300;

export const BASE_STRUCTURAL_STYLE = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    willChange: 'transform, opacity',
    overflowY: 'auto',
};

export const getDefaultStyles = (direction) => ({
    ...BASE_STRUCTURAL_STYLE,
    opacity: 0,
    transform: direction === 'backward' ? 'translateX(-100%)' : 'translateX(100%)',
    transition: 'none',
});

export const transitionStylesPerPhase = {
    entering: (direction) => ({
        opacity: 1,
        transform: 'translateX(0%)',
        transition: `transform ${ANIMATION_DURATION}ms ease-out, opacity ${ANIMATION_DURATION}ms ease-out`,
    }),
    entered: (direction) => ({
        opacity: 1,
        transform: 'translateX(0%)',
        transition: 'none',
    }),
    exiting: (direction) => ({
        opacity: 0,
        transform: direction === 'backward' ? 'translateX(100%)' : 'translateX(-100%)',
        transition: `transform ${ANIMATION_DURATION}ms ease-in, opacity ${ANIMATION_DURATION}ms ease-in`,
    }),
    exited: (direction) => ({
        opacity: 0,
        transform: direction === 'backward' ? 'translateX(-100%)' : 'translateX(100%)',
        transition: 'none',
    }),
};